import { Component, OnInit, Input, ViewChild, SkipSelf, Output, EventEmitter, ViewChildren, QueryList } from '@angular/core';
import { BasicInfo } from 'src/app/models/waiver';
import { ControlContainer, NgForm } from '@angular/forms';
import { CustomFields } from 'src/app/models/custom-fields';
import { CustomFieldComponent } from '../custom-field/custom-field.component';

@Component({
  selector: 'guest-basicinfo-edit',
  templateUrl: './guest-basicinfo-edit.component.html',
  styleUrls: ['./guest-basicinfo-edit.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class GuestBasicinfoEditComponent implements OnInit {
  @Input() info: BasicInfo;
  @Input() formSubmitted: boolean;
  @Input() displayName: string;
  @Input() customIndex: number=0;
  @Input() customFields : CustomFields[];
  @Input() readOnly : boolean;
  @ViewChildren(CustomFieldComponent) customFieldControls : QueryList<CustomFieldComponent>
  constructor() { }

  ngOnInit() {
    if (!this.info) {
      this.info = new BasicInfo();
      this.info.bYear = 0;
    this.info.bMonth = 0;
    this.info.bDate = 0;
    }
  }
  
  onDateChange(date: Date) {
    this.info.bYear = date.getFullYear();
    this.info.bMonth = date.getMonth();
    this.info.bDate = date.getDate();
    this.info.birthDate = date;
  }
  
  
}
